import Helpers from "@/helpers/Helpers";

export default [
  // CONTENT PICKER
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/select",
    name: "ContentPicker",
    component: Helpers.lazyLoad("ContentPickerView", "views/content/contentPicker"),
    meta: { requiresAuth: true }
  },
  // CONTENT LIST
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/:contentType(\\pois)/:featureId?",
    name: "PoiList",
    component: Helpers.lazyLoad("PoiListView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/:contentType(\\geofences)/:featureId?",
    name: "GeofenceList",
    component: Helpers.lazyLoad("GeofenceListView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/:contentType(\\mapObjects)/:featureId?",
    name: "MapObjectList",
    component: Helpers.lazyLoad("MapObjectListView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/:contentType(\\iot-devices)/:featureId?",
    name: "BeaconList",
    component: Helpers.lazyLoad("BeaconListView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/layers/:levelId/:contentType(\\wayfinding-network)/:featureId?",
    name: "WayfindingNetwork",
    component: Helpers.lazyLoad("WayfindingNetworkView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  //   LEVELS
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/edit",
    name: "LevelEdit",
    component: Helpers.lazyLoad("LevelAddEditView", "views/content/levels"),
    children: [
      {
        path: "advanced-configurations",
        name: "EditLevelAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/edit/download",
    name: "LevelEditDownload",
    component: Helpers.lazyLoad("LevelAddEditDownloadView", "views/content/levels"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/new",
    name: "LevelAdd",
    component: Helpers.lazyLoad("LevelAddEditView", "views/content/levels"),
    children: [
      {
        path: "advanced-configurations",
        name: "AddLevelAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId?",
    name: "Levels",
    component: Helpers.lazyLoad("LevelsView", "views/content/levels"),
    meta: { requiresAuth: true }
  },
  //   BUILDINGS
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/edit",
    name: "BuildingEdit",
    component: Helpers.lazyLoad("BuildingAddEditView", "views/content/buildings"),
    children: [
      {
        path: "advanced-configurations",
        name: "EditBuildingAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/new",
    name: "BuildingAdd",
    component: Helpers.lazyLoad("BuildingAddEditView", "views/content/buildings"),
    children: [
      {
        path: "advanced-configurations",
        name: "AddBuildingAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId?",
    name: "Buildings",
    component: Helpers.lazyLoad("BuildingsView", "views/content/buildings"),
    meta: { requiresAuth: true }
  },
  // OUTDOOR GEOFENCES
  {
    path: "clients/:clientId/sites/outdoor-geofences/:outdoorGeofenceId/edit",
    name: "OutdoorGeofenceEdit",
    components: { default: Helpers.lazyLoad("OutdoorGeofenceAddEditView", "views/content/sites") },
    children: [
      {
        path: "advanced-configurations",
        name: "EditOutdoorGeofenceAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedContentConfigs", "views/content/mapDesigner"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/outdoor-geofences/new",
    name: "OutdoorGeofenceAdd",
    components: { default: Helpers.lazyLoad("OutdoorGeofenceAddEditView", "views/content/sites") },
    children: [
      {
        path: "advanced-configurations",
        name: "AddOutdoorGeofenceAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedContentConfigs", "views/content/mapDesigner"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/outdoor-geofences/:outdoorGeofenceId?",
    name: "OutdoorGeofences",
    component: Helpers.lazyLoad("SitesView", "views/content/sites"),
    meta: { requiresAuth: true }
  },
  //   SITES
  {
    path: "clients/:clientId/sites/:siteId/edit",
    name: "SiteEdit",
    components: { default: Helpers.lazyLoad("SiteAddEditView", "views/content/sites") },
    children: [
      {
        path: "advanced-configurations",
        name: "EditSiteAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/new",
    name: "SiteAdd",
    components: { default: Helpers.lazyLoad("SiteAddEditView", "views/content/sites") },
    children: [
      {
        path: "advanced-configurations",
        name: "AddSiteAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId?",
    name: "Sites",
    component: Helpers.lazyLoad("SitesView", "views/content/sites"),
    meta: { requiresAuth: true }
  },
  //   CLIENTS
  {
    path: "clients/:clientId/edit",
    name: "ClientEdit",
    component: Helpers.lazyLoad("ClientAddEditView", "views/content/clients"),
    children: [
      {
        path: "advanced-configurations",
        name: "EditClientAdvancedConfigurations",
        component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
        meta: { requiresAuth: true }
      }
    ],
    meta: { requiresAuth: true }
  },
  // TODO: Uncomment when multi client is implemented
  // {
  //   path: "clients/new",
  //   name: "ClientAdd",
  //   component: Helpers.lazyLoad("ClientAddEditView", "views/content/clients"),
  //   children: [
  //     {
  //       path: "advanced-configurations",
  //       name: "AddClientAdvancedConfigurations",
  //       component: Helpers.lazyLoad("AdvancedSdkConfigs", "views/content"),
  //       meta: { requiresAuth: true }
  //     }
  //   ],
  //   meta: { requiresAuth: true }
  // },
  {
    path: "clients/:clientId?",
    name: "Clients",
    component: Helpers.lazyLoad("ClientsView", "views/content/clients"),
    meta: { requiresAuth: true }
  },
  {
    path: "preview",
    name: "Preview",
    component: Helpers.lazyLoad("ContentView", "views"),
    meta: { requiresAuth: true }
  }
];
